module.exports = __webpack_public_path__ + "img/end_page_oj.eb15a675.jpg";